enum ParentAnswerTypeEnum {
  Fullname = "Fullname",
  BirthYear = "BirthYear",
  Profession = "Profession",
  Qualifications = "Qualifications",
  Mobile = "Mobile",
  Email = "Email",
}

export default ParentAnswerTypeEnum;
